import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import StreetContent from './StreetContent';
import StreetModal from '../components/StreetModal';

const form = {
  keyword: '',
};

function StreetContainer({
  match,
  history,
  getStreetList,
  streetList,
  isLoading,
  removeStreet,
  streetListPager,
  getSingleStreet,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <StreetModal type="NEW" />,
      title: 'Add Street',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <StreetModal type="EDIT" updateList={data.attributes} streetId={data.id} />,
      title: 'Update Street',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Street?',
      () => {
        removeStreet(data.id, () => {
          getStreetList();
          const id = _.get(streetList, '0.id');
          if (id !== data.id) {
            history.push(`${id}`);
            getSingleStreet(id);
          } else {
            window.location.pathname = '/rpt/settings/property-locations/streets';
            history.replace({
              pathname: '/rpt/settings/property-locations/streets',
            });
          }
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getStreetList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getStreetList({ q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:streetId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Streets"
            getData={getStreetList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:streetId?`}
            listName="Streets"
            label="Streets"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.name')}</div>
            )}
            isLoading={isLoading}
            selected={params.streetId}
            data={streetList}
            dataPager={streetListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:streetId?`}
                    render={() => (
                      <StreetContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:streetId?`}
                  render={() =>
                    !params.streetId && streetList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(streetList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

StreetContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getStreetList: PropTypes.instanceOf(Function).isRequired,
  streetList: PropTypes.instanceOf(Array).isRequired,
  streetListPager: PropTypes.instanceOf(Object).isRequired,
  removeStreet: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleStreet: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  streetList: _.get(api, `${c.GET_STREETS}.list`) || [],
  streetListPager: _.get(api, `${c.GET_STREETS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_STREETS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(StreetContainer);
